import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import { Icon } from '@iconify/react';
import AuthorWidget from '../Widget/AuthorWidget';
import { pageTitle } from '../../helpers/PageTitle';

export default function Blog4() {
  pageTitle('Wind Energy Solutions: Powering Business Growth');
  
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = {
      name: formData.get('name'),
      email: formData.get('email'),
      comment: formData.get('comment')
    };
    console.log('Sending to company email:', data);
  };

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Wind Energy Solutions: Powering Business Growth"
        variant="text-center"
        shape="shape_5"
        category="Wind Energy"
        date="22 Nov 2024"
        avatar="Business Energy"
        avatarLink="/"
      />
      <Spacing lg="75" md="60" />
      <div className="container">
        <img
          src="/images/blog/post_details_1.jpeg"
          alt="Wind Energy Solutions"
          className="cs_radius_15"
        />
        <div className="cs_height_60 cs_height_lg_40" />
        <div className="cs_post_details">
          <h3>
            Harnessing Wind Power for Sustainable Business Operations
          </h3>
          <p>
            Wind energy is revolutionizing how businesses meet their power needs. With modern turbine technology, companies can now generate significant portions of their energy requirements through wind power, reducing costs and environmental impact.
          </p>
          <p>
            Our latest wind energy installations have demonstrated potential energy cost reductions of 40-65% for businesses with suitable locations, while providing a reliable and sustainable power source.
          </p>
          <div className="cs_height_10 cs_height_lg_5" />
          <div className="row">
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_2.jpeg"
                alt="Wind Turbines"
                className="w-100"
              />
            </div>
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_3.jpeg"
                alt="Energy Generation"
                className="w-100"
              />
            </div>
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_4.jpeg"
                alt="Business Implementation"
                className="w-100"
              />
            </div>
          </div>
          <div className="cs_height_10 cs_height_lg_5" />
          <h3>The Business Case for Wind Energy</h3>
          <p>
            Modern wind energy systems offer unprecedented efficiency and reliability. Our turnkey solutions include site assessment, installation, and ongoing maintenance to ensure optimal performance throughout the system's lifecycle.
          </p>
          <blockquote>
            "Switching to wind energy was a game-changer for our agricultural operations. We've cut our energy costs by 55% while maintaining reliable power supply throughout the year."
            <small>David Thompson, Green Valley Farms</small>
          </blockquote>
          <p>
            Soketry Solutions provides comprehensive wind energy solutions tailored to your business needs, including hybrid systems that combine wind with solar power for maximum efficiency.
          </p>
          <ul>
            <li>Comprehensive site assessment and wind analysis</li>
            <li>Custom turbine selection and placement</li>
            <li>Grid integration and power management systems</li>
            <li>Maintenance and performance monitoring</li>
            <li>Hybrid system options (wind + solar)</li>
          </ul>
        </div>
        <div className="cs_height_30 cs_height_lg_10" />
        <div className="cs_post_share">
          <div className="cs_categories">
            <a href="/" className="cs_category">
              Wind Power
            </a>
            <a href="/" className="cs_category">
              Business Energy
            </a>
          </div>
          <div className="text-center">
            <div className="cs_post_share_btns">
              <a href="/">
                <Icon icon="fa6-brands:twitter" />
              </a>
              <a href="/">
                <Icon icon="fa6-brands:facebook-f" />
              </a>
              <a href="/">
                <Icon icon="fa6-brands:linkedin-in" />
              </a>
            </div>
            <span className="cs_post_share_title">Share this Article</span>
          </div>
        </div>
        <div className="cs_height_50 cs_height_lg_40" />
        <AuthorWidget />
        <div className="cs_height_88 cs_height_lg 60" />
        <h2 className="text-center cs_fs_50 mb-0">Leave A Comment</h2>
        <div className="cs_height_60 cs_height_lg 30" />
        <form onSubmit={handleSubmit} className="row">
          <div className="col-lg-6">
            <input
              type="text"
              name="name"
              className="cs_form_field_2"
              placeholder="Your Name"
              required
            />
            <div className="cs_height_50 cs_height_lg 30" />
          </div>
          <div className="col-lg-6">
            <input
              type="email"
              name="email"
              className="cs_form_field_2"
              placeholder="Your Email"
              required
            />
            <div className="cs_height 50 cs_height_lg 30" />
          </div>
          <div className="col-lg-12">
            <textarea
              name="comment"
              cols={30}
              rows={7}
              className="cs_form_field_2"
              placeholder="Share your thoughts on wind energy solutions"
              required
            />
            <div className="cs_height 60 cs_height_lg 30" />
          </div>
          <div className="col-lg-12 text-center">
            <button type="submit" className="cs_btn cs_style_1">
              Submit Comment{' '}
              <span>
                <i className="fa-solid fa-arrow-right" />
              </span>
            </button>
          </div>
        </form>
        <div className="cs_height_150 cs_height_lg 80" />
      </div>
    </>
  );
} 